<!--
* @author 肖阳
* @time 2020-9-10
* @dec 添加新增节点按钮
-->
<script>
/* eslint-disable no-unused-vars */
import "./addBox.less";
import { NextNode } from "@/CommonDP/components/DrawFlow/src/components/DrawAddSelectBox/NextNode";
export default {
  name: "AddBox",
  props: {
    nodeConfig: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      boxArr: [
        {
          type: "2",
          value: "节点",
          row: true,
          calssName: "approver",
          image: require("./../image/node.png"),
          icon: "el-icon-user"
        },
        {
          type: "3",
          value: "条件分支",
          row: false,
          calssName: "route",
          image: require("./../image/branch.png"),
          icon: "el-icon-s-operation"
        }
      ]
    };
  },
  methods: {
    clickSelectBox(item) {
      this.getNexttBox(item);
    },
    getNexttBox(item) {
      const nodeConfig = this.nodeConfig;
      if (item.value === "流转至") {
        this.nodeConfig.isFlowTo = true;
      }
      const { id, prevId, type, row, title, conditionRank } = Object.assign(nodeConfig, item);
      const nextNode = new NextNode({ id, prevId, type, row, title, conditionRank });
      this.$emit("clickSelectBox", nextNode);
    },
    renderAddSBox() {
      return (
        <div class='add-node-popover'>
          <div class='add-node-popover-body'>
            {this.boxArr.map(item => {
              return (
                <a
                  onClick={() => {
                    this.clickSelectBox(item);
                  }}
                  class={["add-node-popover-item", item.calssName]}
                >
                  <div class='item-wrapper'>
                    <img src={item.image} alt='图标' />
                  </div>
                  <span>{item.value}</span>
                </a>
              );
            })}
          </div>
        </div>
      );
    }
  },
  render() {
    return this.renderAddSBox();
  }
};
</script>
